module.exports = __webpack_public_path__ + "static/media/gg_titlebar_arrow_default.4f86b7a8.svg";